export type OperationFoldersItemData = {};

export type OperationFoldersPagination = {
  "@id": string;
  type: string;
  first: string;
  last: string;
  previous: string;
  next: string;
};

/* export type ActivitySearchMappingItem = {
  "@type": string;
  variable: string;
  property: string;
  required: boolean;
}; */

/* export type ActivitySearch = {
  "@type": string;
  template: string;
  variableRepresentation: string;
  mapping: ActivitySearchMappingItem[];
}; */

export type OperationFoldersListResponse = {
  member: OperationFoldersItemData[];
  totalItems: number;
  view: OperationFoldersPagination;
  // search: ActivitySearch;
};

export type OperationFoldersPageState = {
  page: number;
  itemsPerPage?: number;
  pagination?: boolean;
  name?: string | null;
  address?: string | null;
  reference?: string | null;
  q?: string | null;
  order?: { dataKey: string; order?: "asc" | "desc" };
};

export type OperationFoldersListStateType = {
  pageState: OperationFoldersPageState;
  setPageState: (state: OperationFoldersPageState) => void;
  resetPageState: () => void;
};

export const initialOperationFoldersPageState: OperationFoldersPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
